/**
 * TypographySection.tsx
 * Typography section showing text hierarchy and styling
 */

import React from 'react';
import { Card, CardHeader, CardBody } from '@enfomentis/ui';
import { Divider } from '@enfomentis/ui';

const textDemos = [
  { name: 'Primary Text', classes: 'text-text-primary', sample: 'Main content text' },
  { name: 'Secondary Text', classes: 'text-text-secondary', sample: 'Supporting information' },
  { name: 'Tertiary Text', classes: 'text-text-tertiary', sample: 'Subtle details' },
  { name: 'Inverse Text', classes: 'text-text-inverse bg-primary px-2 py-1 rounded', sample: 'Text on dark backgrounds' },
];

export const TypographySection: React.FC = () => {
  return (
    <div className="space-y-6">
      <Card shadow="lg" isHoverable>
        <CardHeader>
          <h3 className="text-xl font-semibold text-text-primary">Typography System</h3>
        </CardHeader>
        <CardBody>
          <div className="space-y-6">
            {textDemos.map((text) => (
              <div key={text.name} className="space-y-2">
                <h4 className="text-sm font-medium text-text-secondary">{text.name}</h4>
                <p className={`text-lg ${text.classes}`}>{text.sample}</p>
                <Divider />
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};